const LOCAL_STORAGE_WISHLIST_KEY = "shopify-wishlist";
const LOCAL_STORAGE_DELIMITER = ",";
const BUTTON_ACTIVE_CLASS = "active";
const GRID_LOADED_CLASS = "loaded";
const GRID_ACTIVE_CLASS = "active";
const EMPTY_WISHLIST_MESSAGE = "No products";

const selectors = {
  button: "[button-wishlist]",
  grid: "[grid-wishlist]",
  productCard: ".product-card",
  emptyMessage: ".wishlist-empty-message",
};

document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    initButtons(); 
    initGrid(); 

    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === "childList") {
          const addedNodes = Array.from(mutation.addedNodes);
          addedNodes.forEach((node) => {
            if (
              node.nodeType === Node.ELEMENT_NODE &&
              node.querySelector(selectors.button)
            ) {
              initButtons(); 
            }
          });
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true, // Наблюдаем за вложенными элементами
    });
  }, 1500);
});

document.addEventListener("shopify-wishlist:updated", (event) => {
  console.log("[Shopify Wishlist] Wishlist Updated ✅", event.detail.wishlist);
  initGrid();
});

document.addEventListener("shopify-wishlist:init-product-grid", (event) => {
  console.log(
    "[Shopify Wishlist] Wishlist Product List Loaded ✅",
    event.detail.wishlist,
  );
});

document.addEventListener("shopify-wishlist:init-buttons", (event) => {
  console.log(
    "[Shopify Wishlist] Wishlist Buttons Loaded ✅",
    event.detail.wishlist,
  );
});

const fetchProductCardHTML = (handle) => {
  const productTileTemplateUrl = `/products/${handle}?view=card`;
  return fetch(productTileTemplateUrl)
    .then((res) => res.text())
    .then((res) => {
      const text = res;
      const parser = new DOMParser();
      const htmlDocument = parser.parseFromString(text, "text/html");
      const productCard = htmlDocument.documentElement.querySelector(
        selectors.productCard,
      );
      return productCard.outerHTML;
    })
    .catch((err) =>
      console.error(
        `[Shopify Wishlist] Failed to load content for handle: ${handle}`,
        err,
      ),
    );
};

const setupGrid = async (grid) => {
  const wishlist = getWishlist();
  if (wishlist.length === 0) {
    grid.innerHTML = `<p class="${selectors.emptyMessage.slice(
      1,
    )}">${EMPTY_WISHLIST_MESSAGE}</p>`;
    grid.classList.remove(GRID_ACTIVE_CLASS);
    grid.classList.add(GRID_LOADED_CLASS);
    return;
  }
  const requests = wishlist.map(fetchProductCardHTML);
  const responses = await Promise.all(requests);
  const wishlistProductCards = responses.join("");
  grid.innerHTML = wishlistProductCards;
  grid.classList.add(GRID_LOADED_CLASS);
  grid.classList.add(GRID_ACTIVE_CLASS); // Add active class when wishlist is not empty
  initButtons();

  const event = new CustomEvent("shopify-wishlist:init-product-grid", {
    detail: { wishlist: wishlist },
  });
  document.dispatchEvent(event);
};

const setupButtons = (buttons) => {
  buttons.forEach((button) => {
    if (button.dataset.initialized) return;

    button.dataset.initialized = "true";
    const productHandle = button.dataset.productHandle || false;

    if (!productHandle) {
      return console.error(
        "[Shopify Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist."
      );
    }

    if (wishlistContains(productHandle)) {
      button.classList.add(BUTTON_ACTIVE_CLASS);
      if (button.classList.contains('wishlist-button-product') ) {
      button.innerText = "Remove from wishlist";
      }
    }

    button.addEventListener("click", () => {
      updateWishlist(productHandle);
      button.classList.toggle(BUTTON_ACTIVE_CLASS);
      if (button.classList.contains('wishlist-button-product') ) {
            if (button.classList.contains('active')) {
              button.innerText = "Remove from wishlist";
            } else {
              button.innerText = "Add to wishlist";
            }
      }
    });
  });
};

const initGrid = () => {
  const grid = document.querySelector(selectors.grid) || false;
  if (grid) setupGrid(grid);
};

const initButtons = () => {
  const buttons = document.querySelectorAll(
    `${selectors.button}:not([data-initialized])`
  );
  if (buttons.length) {
    setupButtons(buttons);
  }

  const event = new CustomEvent("shopify-wishlist:init-buttons", {
    detail: { wishlist: getWishlist() },
  });
  document.dispatchEvent(event);
};

const getWishlist = () => {
  const wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;
  if (wishlist) return wishlist.split(LOCAL_STORAGE_DELIMITER);
  return [];
};

const setWishlist = (array) => {
  const wishlist = array.join(LOCAL_STORAGE_DELIMITER);
  if (array.length) localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlist);
  else localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);

  const event = new CustomEvent("shopify-wishlist:updated", {
    detail: { wishlist: array },
  });
  document.dispatchEvent(event);

  return wishlist;
};

const updateWishlist = (handle) => {
  const wishlist = getWishlist();
  const indexInWishlist = wishlist.indexOf(handle);
  if (indexInWishlist === -1) wishlist.push(handle);
  else wishlist.splice(indexInWishlist, 1);
  return setWishlist(wishlist);
};

const wishlistContains = (handle) => {
  const wishlist = getWishlist();
  return wishlist.includes(handle);
};

const resetWishlist = () => {
  return setWishlist([]);
};

// Wish list button from product page
const wishListButtonProduct = document.querySelector(
  ".wishlist-button-product",
);

if (wishListButtonProduct) {
  let wishListButtonProductActive =
    wishListButtonProduct.classList.contains("active");

  // Set initial text based on the active state
  wishListButtonProduct.innerHTML = wishListButtonProductActive
    ? "Remove from wishlist"
    : "Add to wishlist";

  wishListButtonProduct.addEventListener("click", () => {
    wishListButtonProductActive = !wishListButtonProductActive;

    if (wishListButtonProductActive) {
      wishListButtonProduct.innerHTML = "Remove from wishlist";
    } else {
      wishListButtonProduct.innerHTML = "Add to wishlist";
    }
  });
}
